import { render, staticRenderFns } from "./DisqualifyModal.vue?vue&type=template&id=33f3dd50"
import script from "./DisqualifyModal.vue?vue&type=script&lang=js"
export * from "./DisqualifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports